import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../config/firebaseConfig";
import { FaCaretDown } from "react-icons/fa6";
import { LuLayoutDashboard, LuLogOut } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa";
import { useAuthState } from "react-firebase-hooks/auth";
import { GAEventTrack } from "../../utils/hooks/GA_events";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/features/authSlice";
import { Button } from "../../components";

const calendlyMeetingLink = "https://calendly.com/shilpi-lamba/meeting";

const Header = ({ placement, userType = "", name, photoUrl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location?.pathname;
  const [userAuth, authLoading] = useAuthState(auth);
  const { userDetails } = useSelector((state) => state.auth);
  const headerRef = useRef(null);
  const menuBtnRef = useRef(null);
  const menuRef = useRef(null);
  const menuBlocksRef = useRef(null);
  const navHeaderRef = useRef(null);
  const subHeaderRef = useRef(null);
  const profileMenuRef = useRef(null);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);

  // useEffect(() => {
  //     window.addEventListener('scroll', () => {
  //         const scrollPositionToShowHeader = 50; // Change this value to set when the header should change color
  //         if (window.scrollY > scrollPositionToShowHeader) {
  //             headerRef.current.classList.add('header-scrolled');
  //         } else {
  //             headerRef.current.classList.remove('header-scrolled');
  //         }
  //     });
  // },[])

  useEffect(() => {
    const clickOutsideProfileMenu = (event) => {
      // console.log(event.target);
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setProfileMenuOpen(false);
      }
    };
    if (profileMenuOpen) {
      document.addEventListener("mousedown", clickOutsideProfileMenu);
    } else {
      document.removeEventListener("mousedown", clickOutsideProfileMenu);
    }

    return () => {
      document.removeEventListener("mousedown", clickOutsideProfileMenu);
    };
  }, [profileMenuOpen]);

  useEffect(function () {
    if (document.getElementById("feature-data")) {
      window.addEventListener("scroll", function () {
        if (window.scrollY > 100) {
          if (subHeaderRef.current) {
            subHeaderRef.current.style.top = "0";
          }
        } else {
          if (subHeaderRef.current) {
            subHeaderRef.current.style.top = "80px";
          }
        }
      });
    }
  }, []);

  const activateMenu = (e) => {
    var self = e.currentTarget;
    if (menuRef.current.classList.contains("active")) {
      self.classList.remove("active");
      menuBlocksRef.current.classList.remove("active");
      menuRef.current.classList.remove("active");
      navHeaderRef.current.classList.remove("active");
    } else {
      self.classList.add("active");
      menuBlocksRef.current.classList.add("active");
      menuRef.current.classList.add("active");
      navHeaderRef.current.classList.add("active");
    }
  };

  const clickToScroll = (e) => {
    e.preventDefault();
    const targetId = e.target.getAttribute("href");
    if (placement === "landingPage") {
      const targetElement = document.querySelector(targetId);
      const offset = targetElement.offsetTop;
      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
      if (menuBtnRef.current.classList.contains("active")) {
        menuRef.current.classList.remove("active");
        menuBlocksRef.current.classList.remove("active");
        menuBtnRef.current.classList.remove("active");
        navHeaderRef.current.classList.remove("active");
      } else {
        menuBtnRef.current.classList.add("active");
        menuBlocksRef.current.classList.add("active");
      }
    } else {
      navigate("/");
    }
  };

  function handleLogoClick() {
    if (placement === "dashboard" && userDetails) {
      navigate(`/${userDetails?.accountType}Dashboard`);
    } else {
      navigate("/");
    }

    // setTimeout(function () {
    window.scroll({ top: 0, behavior: "smooth" });
    // }, 100);
  }

  const socialList = [
    {
      name: "facebook",
      imgSrc: "/img/social/fb.png",
      href: "https://www.facebook.com/profile.php?id=100095416683665",
    },
    {
      name: "instagram",
      imgSrc: "/img/social/insta.png",
      href: "https://www.instagram.com/practido",
    },
    {
      name: "twitter",
      imgSrc: "/img/social/tw.png",
      href: "https://twitter.com/olympiad_p",
    },
    {
      name: "youtube",
      imgSrc: "/img/social/youtube.png",
      href: "https://youtube.com/@OlympiadPracticeApp?feature=shared",
    },
    {
      name: "whatsapp",
      imgSrc: "/img/social/whatapp.png",
      href: "https://whatsapp.com/channel/0029Va50kJ33rZZbb9X3za1q",
    },
    {
      name: "email",
      imgSrc: "/img/social/email.png",
      href: "mailto:hello@practido.com",
    },
  ];

  const logSocialGA = (name) => {
    GAEventTrack({ event: `social_${name}_btn`, data: { button_name: name } });
  };

  const handleLogOut = async () => {
    const isSchoolDashboard = path?.includes("/schoolDashboard");
    const isParentDashboard = path?.includes("/parentDashboard");

    try {
      await dispatch(logout()).unwrap();
    } catch (error) {
      console.log(error);
    } finally {
      if (isSchoolDashboard) {
        navigate("/login/school");
      } else if (isParentDashboard) {
        navigate("/login/individual");
      } else {
        navigate("/login");
      }
    }
  };

  return (
    <section id="header" className="header-section olympiad-header">
      <header className="" ref={headerRef}>
        <nav className="navbar navbar-light fixed-top" style={{ zIndex: 1031 }}>
          <div className="container">
            <div className="nav-header" ref={navHeaderRef}>
              <div className="navbar-brand logo" onClick={handleLogoClick}>
                <img src="/img/logo.webp" alt="logo" />
              </div>

              <div className="mobile-playstore d-none">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice"
                  className="menu__link btn white-btn"
                >
                  <span>
                    <img src="/img/new-home/play-icon.png" alt="google play" />{" "}
                    Google Play
                  </span>
                </a>
              </div>
              <div
                className="menu-icon"
                ref={menuBtnRef}
                onClick={activateMenu}
              >
                <span className="line"></span>
                <span className="line"></span>
                <span className="line"></span>
              </div>
            </div>
            <div className="menu menu__m-view" ref={menuRef}>
              {/* {(placement === "register" || placement === "dashboard") && (
                <ul className="reg-header menu-list menu-list--left mb-header-nav">
                  {placement === "dashboard" ? (
                    <li className="menu__item mega-menu-item">
                      <NavLink
                        to={`/${userDetails?.accountType}Dashboard`}
                        className={`menu__link ${
                          path === "/schoolDashboard" ||
                          path === "/parentDashboard"
                            ? "active"
                            : "not-active"
                        }`}
                      >
                        Dashboard
                      </NavLink>
                    </li>
                  ) : (
                    <li className="menu__item mega-menu-item">
                      <NavLink
                        to="/register"
                        className={({ isActive }) =>
                          `menu__link ${isActive ? "active" : "not-active"}`
                        }
                      >
                        Practido Registration
                      </NavLink>
                    </li>
                  )}

                  {userDetails?.accountType === "school" ? (
                    <>
                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/schoolDashboard/registeredStudents"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          Registered
                        </NavLink>
                      </li>
                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/schoolDashboard/results"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          Results
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/faqLanding"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          FAQs
                        </NavLink>
                      </li>
                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/syllabusLanding"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          Syllabus
                        </NavLink>
                      </li>
                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/examLanding"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          Exam Dates
                        </NavLink>
                      </li>

                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/instructions"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          Instructions
                        </NavLink>
                      </li>
                      <li className="menu__item mega-menu-item">
                        <NavLink
                          to="/awardsLanding"
                          className={({ isActive }) =>
                            `menu__link ${isActive ? "active" : "not-active"}`
                          }
                        >
                          Awards
                        </NavLink>
                      </li>
                    </>
                  )}
                </ul>
              )} */}
              {/* {placement === "dashboard" && userDetails && (
                <>
                  <div className="mobile-logout flex flex-col gap-3 px-2 lg:hidden absolute mgt20">
                    <div className="flex items-center gap-2">
                      <div className="flex flex-col">
                        <span className="font-semibold text-base">
                          {authLoading ? "Loading" : userAuth?.displayName}
                        </span>
                        <span className="text-sm">
                          {authLoading
                            ? "loading"
                            : userAuth?.email || userAuth?.phoneNumber}
                        </span>
                      </div>
                    </div>
                    <div
                      className="text-red-500 flex items-center gap-2 cursor-pointer"
                      onClick={handleLogOut}
                    >
                      <LuLogOut className="w-6 h-6" />
                      <span className="font-bold">Logout</span>
                    </div>
                  </div>
                  <div className="gap-8 items-center hidden lg:flex">
                    <div
                      className="logout-dropdown relative primary-btn flex items-center px-6 gap-10 justify-between"
                      onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                    >
                      <span className="name font-semibold capitalize">
                        {authLoading ? "loading" : userAuth?.displayName}
                      </span>
                      <FaCaretDown />
                      {profileMenuOpen && (
                        <div
                          className="absolute top-16 right-0 rounded-2xl bg-[#ECF0F1] shadow-[0px_4px_0px_0px_#A9A9A9] overflow-hidden"
                          ref={profileMenuRef}
                        >
                          <ul className="text-gray-700 font-bold">
                            <div className="flex gap-2 p-3 px-4 border-b-2 border-gray-300">
                              <div className="w-12 h-12 rounded-full bg-[#F2B010]/20 flex items-center justify-center">
                                <FaRegUser className="w-7 h-7 text-[#F2B010]" />
                              </div>
                              <div className="flex flex-col">
                                <span className="font-semibold capitalize">
                                  {userAuth?.displayName}
                                </span>
                                <span className="text-sm">
                                  {userAuth?.email
                                    ? userAuth?.email
                                    : userAuth?.phoneNumber}
                                </span>
                              </div>
                            </div>
                            
                            <li
                              className="p-3 px-4 hover:bg-[#E5E5F1] mb-2 text-red-500 flex items-center gap-2"
                              onClick={handleLogOut}
                            >
                              <LuLogOut className="w-6 h-6" />
                              Logout
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )} */}
              {
                // placement === "landingPage" &&
                true && (
                  <ul className="menu-list menu-list--left mb-header-nav olympiad-header-list ">
                    <li className="d-none menu__item mega-menu-item">
                      <a
                        href="/"
                        // onClick={clickToScroll}
                        className="menu__link"
                      >
                        Home
                      </a>
                    </li>
                    {userDetails && (
                      <li className="d-none menu__item mega-menu-item">
                        <Link
                          to={`/${userDetails?.accountType}Dashboard`}
                          className="menu__link"
                        >
                          Dashboard
                        </Link>
                      </li>
                    )}
                    <li className="d-none menu__item mega-menu-item">
                      <a href="/practido-for-schools" className="menu__link">
                        Schools
                      </a>
                    </li>
                    <li className="d-none menu__item mega-menu-item">
                      <a href="/practido-for-parents" className="menu__link">
                        Parents
                      </a>
                    </li>
                    <li className="d-none menu__item mega-menu-item">
                      <a href="/practido-for-educators" className="menu__link">
                        Educators
                      </a>
                    </li>
                    <li className="d-none menu__item mega-menu-item">
                      <Link to="/ai-robotics-coding-classes-for-kids" className="menu__link">
                        Robotics Lab
                      </Link>
                    </li>
                    <li className="d-none menu__item mega-menu-item">
                      <a href="https://practido.com/blog/" className="menu__link">
                        Blogs
                      </a>
                    </li>
                    <li className="d-none menu__item mega-menu-item">
                      <a
                        href="/register/school"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="menu__link"
                      >
                        School Registration
                      </a>
                    </li>

                    {placement === "landingPage" && (
                      <li>
                        <ul className="social-list">
                          {socialList?.map(({ name, href, imgSrc }) => (
                            <li key={name}>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={href}
                                onClick={() => {
                                  logSocialGA(name);
                                }}
                              >
                                <img
                                  width="24"
                                  height="24"
                                  src={imgSrc}
                                  alt={name}
                                />
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}

                    <li className="menu__item mega-menu-item flex gap-2 items-center">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://play.google.com/store/apps/details?id=com.naskay.olympiadpractice"
                        className="menu__link btn white-btn"
                        onClick={() => {
                          GAEventTrack({
                            event: "googlePlay_btn",
                          });
                        }}
                      >
                        <div className="desktop-btn">
                          <img
                            src="/img/new-home/play-icon.png"
                            alt="google play"
                          />
                          Google Play
                        </div>
                        <div className="rounded-xl overflow-hidden lg:hidden">
                          <img
                            src="/img/new-home/btn-google-play-black.png"
                            alt="google play"
                            width={140}
                          />
                        </div>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://apps.apple.com/in/app/practido-olympiad-practice/id6746647468"
                        className="menu__link btn white-btn"
                        onClick={() => {
                          GAEventTrack({
                            event: "applestore_btn",
                          });
                        }}
                      >
                        <div className="desktop-btn">
                          <img
                            src="/img/new-home/apple-icon.png"
                            alt="app store"
                          />
                          App Store
                        </div>
                        <div className="rounded-xl overflow-hidden lg:hidden">
                          <img
                            src="/img/new-home/btn-apple-store-black.png"
                            alt="apple store"
                            width={140}
                          />
                        </div>
                      </a>
                      {!authLoading && userAuth ? (
                        <>
                          <div className="mobile-logout flex flex-col gap-3 px-2 lg:hidden absolute mgt20">
                            <div className="flex items-center gap-2">
                              <div className="flex flex-col">
                                <span className="font-semibold text-base">
                                  {userAuth?.displayName}
                                </span>
                                <span className="text-sm">
                                  {userAuth?.email
                                    ? userAuth?.email
                                    : userAuth?.phoneNumber}
                                </span>
                              </div>
                            </div>
                            <div
                              className="text-red-500 flex items-center gap-2 cursor-pointer"
                              onClick={handleLogOut}
                            >
                              <LuLogOut className="w-6 h-6" />
                              <span className="font-bold">Logout</span>
                            </div>
                          </div>
                          <div className="gap-8 items-center hidden lg:flex">
                            <div
                              className="logout-dropdown relative primary-btn flex items-center px-6 gap-10 justify-between"
                              onClick={() =>
                                setProfileMenuOpen(!profileMenuOpen)
                              }
                            >
                              <span className="name font-semibold capitalize">
                                {userAuth?.displayName}
                              </span>
                              <FaCaretDown />
                              {profileMenuOpen && (
                                <div
                                  className="absolute top-16 right-0 rounded-2xl bg-[#ECF0F1] shadow-[0px_4px_0px_0px_#A9A9A9] overflow-hidden"
                                  ref={profileMenuRef}
                                >
                                  <ul className="text-gray-700 font-bold">
                                    <div className="flex gap-2 p-3 px-4 border-b-2 border-gray-300">
                                      <div className="w-12 h-12 rounded-full bg-[#F2B010]/20 flex items-center justify-center">
                                        <FaRegUser className="w-7 h-7 text-[#F2B010]" />
                                      </div>
                                      <div className="flex flex-col">
                                        <span className="font-semibold capitalize">
                                          {userAuth?.displayName}
                                        </span>
                                        <span className="text-sm">
                                          {userAuth?.email
                                            ? userAuth?.email
                                            : userAuth?.phoneNumber}
                                        </span>
                                      </div>
                                    </div>
                                    <li
                                      className="p-3 px-4 hover:bg-[#E5E5F1] mb-2 flex items-center gap-2"
                                      onClick={() =>
                                        navigate(
                                          `/${userDetails?.accountType}Dashboard`
                                        )
                                      }
                                    >
                                      <LuLayoutDashboard classListName="w-7 h-7" />
                                      Dashboard
                                    </li>

                                    <li
                                      className="p-3 px-4 hover:bg-[#E5E5F1] mb-2 text-red-500 flex items-center gap-2"
                                      onClick={handleLogOut}
                                    >
                                      <LuLogOut className="w-6 h-6" />
                                      Logout
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        placement !== "register" && (
                          <Button
                            handleClick={() => navigate("/login")}
                            version="secondary"
                          >
                            Sign In
                          </Button>
                        )
                      )}
                    </li>
                  </ul>
                )
              }
            </div>
          </div>
          <div className="menu__m-view-blocks" ref={menuBlocksRef}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </nav>
      </header>

      {placement !== "register" &&
        placement !== "dashboard" &&
        placement !== "examModule" && (
          <div ref={subHeaderRef} className="sub-header" style={{ overflow: 'visible' }}>
            <div className="container" style={{ overflow: 'visible' }}>
              <ul style={{ overflow: 'visible' }}>
                {[
                  { name: "home", location: "/", external: false },
                  { name: "schools", location: "/practido-for-schools", external: false },
                  { name: "parents", location: "/practido-for-parents", external: false },
                  { name: "educators", location: "/practido-for-educators", external: false  },
                  { name: "Robotics Lab", location: "/ai-robotics-coding-classes-for-kids", external: false },
                  { name: "Blogs", location: "https://practido.com/blog/", external: true },
                  { 
                    name: "Products & Services", 
                    location: "#", 
                    external: false,
                    dropdown: [
                      { name: "Practido - Olympiad Practice App", location: "/" },
                      { name: "Robotics AI Labs for Schools", location: "/ai-lab-schools" },
                      { name: "Practido Learning Center", location: "/ai-robotics-coding-classes-for-kids" },
                      { name: "Practido Online Coaching Classes", location: "/coaching" },
                      { name: "Practido Olympiad & Competition & Challenges", location: "/copetitions" },
                      { name: "Practido AI Assessment Online Exam Platform", location: "/assessment" }
                    ]
                  },
                  {
                    name: "School Registration",
                    location: "/register/school",
                  },
                ]?.map((item) => (
                  <li 
                    key={item.name} 
                    className="menu__item mega-menu-item relative"
                    onMouseEnter={(e) => {
                      const dropdown = e.currentTarget.querySelector('.custom-dropdown-panel');
                      if (dropdown) dropdown.classList.remove('hidden');
                    }}
                    onMouseLeave={(e) => {
                      const dropdown = e.currentTarget.querySelector('.custom-dropdown-panel');
                      if (dropdown) dropdown.classList.add('hidden');
                    }}
                  >
                    {item.dropdown ? (
                      <>
                        <a
                          href={item.location}
                          onClick={(e) => e.preventDefault()}
                          className={`btn primary-btn ${path === item.location ? "active" : ""} capitalize`}
                          style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}
                        >
                          {item.name}
                          <FaCaretDown />
                        </a>
                        <div className="custom-dropdown-panel absolute top-[100%] left-0 hidden w-[320px] pt-2 z-[9999]">
                          <div className="bg-white shadow-lg rounded-xl overflow-hidden border border-gray-100">
                            <ul className="flex flex-col text-left m-0 p-0 !gap-0" style={{ overflow: 'visible' }}>
                              {item.dropdown.map((dropItem) => {
                                const isDropActive = path === dropItem.location;
                                return (
                                  <li key={dropItem.name} className={`border-b border-gray-100 last:border-b-0 hover:bg-[#F2B010]/10 transition-colors w-full h-full p-0 m-0 !border-none ${isDropActive ? "bg-[#F2B010]/10" : ""}`}>
                                    <Link 
                                      to={dropItem.location} 
                                      className={`block px-4 py-3 text-sm font-semibold w-full hover:text-[#F2B010] ${isDropActive ? "text-[#F2B010]" : "text-gray-800"}`}
                                      style={{ textDecoration: 'none' }}
                                    >
                                      {dropItem.name}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </>
                    ) : item.external ? (
                    <a
                      href={item.location}
                      className="btn primary-btn capitalize"
                      target="_self"
                      rel="noopener noreferrer"
                    >
                      {item.name}
                    </a>
                  ) :(
                    <Link
                      to={item?.location}
                      className={`btn primary-btn ${
                        path === item.location ? "active" : ""
                      } capitalize`}
                      target={
                        item?.location === "/register" ? "_blank" : "_self"
                      }
                    >
                      {item?.name}
                    </Link>
                  )}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      {placement === "register" && userType === "school" && (
        <div ref={subHeaderRef} className="sub-header">
          <div className="w-full h-full flex items-center justify-center text-white text-lg gap-2 bg-[#F39C12]">
            <p className="text-[#684A1B] font-bold">
              Want to see how Practido can work for your school?
            </p>
            <Button
              version="secondary"
              className="scale-[80%]"
              handleClick={() => {
                GAEventTrack({
                  event: "demo_call_btn",
                  data: { page: "school-register-subheader" },
                });
                window.open(calendlyMeetingLink, "_blank");
              }}
            >
              Book a Call
            </Button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Header;
